import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=6e1833fa&scoped=true&"
import script from "./ActionButton.vue?vue&type=script&lang=ts&"
export * from "./ActionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1833fa",
  null
  
)

export default component.exports